module.exports = __webpack_public_path__ + "static/media/utvb.d55f3205.png";